import {ReactFlowInstance, Node, Edge} from "@xyflow/react";
import {RJSFSchema} from "@rjsf/utils";


export function processNodeFormSubmit(context: any, formData: any, reactFlowInstance: ReactFlowInstance): void {
    // debugger;
    let editNode: Node = context.activeEditUiUpdateNode;
    if (editNode === undefined) {
        return;
    }
    editNode.data = formData;

    let allNodes: Node[] = reactFlowInstance.getNodes();
    let newNodes: Node[] = [];
    let activeIds: string[] = [];
    for (const node of allNodes) {
        if (!activeIds.includes(node.id)) {
            activeIds.push(node.id);
            newNodes.push(node);
        }
    }

    let updatedNodes: Node[] = [editNode];
    for (const node of newNodes) {
        if (node.id !== editNode.id) {
            updatedNodes.push(node);
        }
    }
    ;
    reactFlowInstance.updateNodeData(editNode.id, formData);
    context.updateLayoutNodes(updatedNodes);

}

export function processNodeDelete(context: any, reactFlowInstance: ReactFlowInstance): void {
    let nodes: Node[] = context.nodes;
    let newNodes: Node[] = [];
    for (const node of nodes) {
        if (!node.id.includes(context.activeEditUiUpdateNode.id)) {
            newNodes.push(node);
        }
    }

    let edges: Edge[] = context.edges;
    let newEdges: Edge[] = [];
    for (const edge of edges) {
        if (!edge.id.includes(context.activeEditUiUpdateNode.id)) {
            newEdges.push(edge);
        }
    }
    context.updateLayoutNodes(newNodes);
    context.updateLayoutEdges(newEdges);
}

export const formSchema: RJSFSchema = {
    title: '',
    type: 'object',
    properties: {
        message: {
            title: 'Message',
            type: 'string',
        },
        icon: {
            title: 'Icon',
            type: 'string',
            anyOf: [
                { const: 'no_icon', title: 'No Icon' },
                { const: 'analyse', title: 'Analyse' },
                { const: 'error', title: 'Error' },
                { const: 'looking', title: 'Looking' },
                { const: 'processing', title: 'Processing' },
                { const: 'planning', title: 'Planning' },
                { const: 'researching', title: 'Researching' },
                { const: 'reviewing', title: 'Reviewing' },
                { const: 'success', title: 'Success' },
                { const: 'thinking', title: 'Thinking' },
                { const: 'writing', title: 'Writing' },

            ]
        }
    },
    required: [ 'message' ]
}

export const nodeDescription: string = "This node is used to send short update messages to the UI. Output is only visible on interactive UI's";